var enc_data = {
    '': {
      'enc_data': [
        ''
      ]
    },
    'data1':"veizjkLtwEaudrossiTGerqSMnviuHLKVEhL",
    'data2':"prjfwWNWfxjAPSWMYkzrLDeWRriaqMQvVZrm",
    'data3':"dFXTKVEDhmPibJvCBVbdPNUjYgDZEnrQSaEE",
    'data4':"HxyVMYEXcDGzNfRppxTNFPzhADFwRyeXgFDZ",
    'data5':"GWzmxjEURnuNJSMqHSqMVhCiwHunHdqXABJD",
    'data6':"EQaPtfPLCsdrowssaPhsaH5DMmIyMJgrrxcr",
    'data7':"tXyfgQKbygxtwYMqNVWyjqPctuVewArdKQNP",
    'data8':"GNzCWEbDWYcKthLYFJmwSrpAmbBMnweBugDX",
    'data9':"QWEhxKBAnUHMHAycqbKWGBtUSrtPDcXWDHBP",
    'data10':"KWGBtUSrtPDcXWDHBPhEarhxVEcFYNZyzXVt",
    'data11':"wivfxprCYZHEudjJtdzLMtLiazUZqPJZiqth",
    'data12':"exRfPtLSrekcahCHxhDHLsgdreKcahRekcah"
  }
  
  export default {
    enc_data
  }
  


// WEBPACK FOOTER //
// ./src/vue/additionalData/codeSalts.js